const Foot_questions = [
   {
      "question":"How is ##name## being evaluated today?",
      "sub":"",
      "type":"radio",
      "telehealth":"F[0].Page_1[0].HowExamCOnducted[0]",
      "show": true,
      "section": {
         page: "1",
         title: "Disability Benefits Questionnaire",
         number: "0"
      },
      "questions":[
         {
            "label":"How was the examination conducted?",
            "title":"",
            "subMain":"",
            "sub":"",
            "radioGroup":"F[0].Page_1[0].RadioButtonList[3]",
            "options":[
               {
                  "main":"In-Person Exam",
                  "dbqName":"1",
                  "sub":""
               },
               {
                  "main":"Video Telehealth",
                  "dbqName":"2",
                  "sub":""
               }
            ],
            "answer":"In-Person Exam"
         }
      ]
   },
   {
      "question":"Is ##name## regularly seen as a patient in your clinic?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "1",
         title: "Disability Benefits Questionnaire",
         number: "0"
      },
      "presidence":"Yes",
      "radioGroup":"F[0].Page_1[0].RadioButtonList[2]",
      "ref":0,
      "dbqName_yes":"1",
      "dbqName_no":"2",
      "answer":"",
   },
   {
      "question":"Did you review any of the patients records for this condition?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "1",
         title: "EVIDENCE REVIEW",
         number: "0"
      },
      "presidence":"Yes",
      "radioGroup":"F[0].Page_1[0].RadioButtonList[0]",
      "ref":0,
      "dbqName_yes":"2",
      "dbqName_no":"1",
      "answer":"",
      "istext": true,
      "textarea": false,
      "placeholder": "Please identify the evidence reviewed and the date range",
      "textdbqName":"F[0].Page_1[0].IdentifyEvidence[0]",
      "textanswer":""
   },
   {
      "question":"Does ##name##'s Respiratory condition require the use of oral or parenteral corticosteroid medication?",
      "sub":"Check all that apply",
      "type":"checkbox",
      "multi": true,
      "small": true,
      "show": true,
      "partial": true,
      "cols": 2,
      "section": {
         page: "3",
         title: "MEDICAL HISTORY",
         number: "2B"
      },
      "questions":[
         {
            "main":"Requires chronic low dose (maintenance) corticosteroids",
            "dbqName":"F[0].Page_3[0].Yes2B[0],F[0].Page_3[0].IfYes1[0]",
            "answer":""
         },
         {
            "main":"Requires intermittent courses or bursts of systemic (oral or parenteral) corticosteroids",
            "dbqName":"F[0].Page_3[0].Yes2B[0],F[0].Page_3[0].IfYes2[0]",
            "answer":"",
            "multi": false,
            "subAnswer":"",
            "subLabel": "Indicate number of courses or bursts in past 12 months",
            "textarea": false,
            "showSubItems": false,
            "subItems": [
               {
                  "main":"0",
                  "dbqName":"F[0].Page_3[0].Zero[0]",
                  "answer":""
               },
               {
                  "main":"1",
                  "dbqName":"F[0].Page_3[0].One[0]",
                  "answer":""
               },
               {
                  "main":"2",
                  "dbqName":"F[0].Page_3[0].Two[0]",
                  "answer":""
               },
               {
                  "main":"3",
                  "dbqName":"F[0].Page_3[0].Three[0]",
                  "answer":""
               },
               {
                  "main":"4 or more",
                  "dbqName":"F[0].Page_3[0].Four[0]",
                  "answer":""
               }
            ],
         },
         {
            "main":"Requires systemic (oral or parenteral) high dose (therapeutic) corticosteroids for control",
            "dbqName":"F[0].Page_3[0].IfYes3[0]",
            "answer":""
         },
         {
            "main":"Requires daily use of systemic (oral or parenteral) high dose corticosteroids",
            "dbqName":"F[0].Page_3[0].IfYes4[1]",
            "answer":""
         },
         {
            "main":"Requires daily use of systemic (oral or parenteral) immuno-suppressive medications",
            "dbqName":"F[0].Page_3[0].IfYes4[0]",
            "answer":""
         },
         {
            "main":"Not required",
            "partialField": true,
            "dbqName":"F[0].Page_3[0].No2B[0]",
            "answer":""
         },         
      ],
      "answer":""
   },
   {
      "question":"Does ##name##'s Respiratory condition require the use of inhaled medication?",
      "sub":"Check all that apply",
      "type":"checkbox",
      "multi": true,
      "small": true,
      "show": true,
      "partial": true,
      "cols": 2,
      "section": {
         page: "3",
         title: "MEDICAL HISTORY",
         number: "2C"
      },
      "questions":[
         {
            "main":"Inhalational bronchodilator therapy",
            "dbqName":"F[0].Page_3[0].IfYesCheck1[0],F[0].Page_3[0].Yes2C[0]",
            "answer":"",
            "multi": false,
            "subAnswer":"",
            "textarea": false,
            "showSubItems": false,
            "subItems": [
               {
                  "main":"Intermittent",
                  "dbqName":"F[0].Page_3[0].Intermittent[0]",
                  "answer":""
               },
               {
                  "main":"Daily",
                  "dbqName":"F[0].Page_3[0].Daily[0]",
                  "answer":""
               }
            ],
         },
         {
            "main":"Inhalational anti-inflammatory medication",
            "dbqName":"F[0].Page_3[0].IfYesCheck2[0],F[0].Page_3[0].Yes2C[0]",
            "answer":"",
            "multi": false,
            "subAnswer":"",
            "textarea": false,
            "showSubItems": false,
            "subItems": [
               {
                  "main":"Intermittent",
                  "dbqName":"F[0].Page_3[0].Intermittent1[0]",
                  "answer":""
               },
               {
                  "main":"Daily",
                  "dbqName":"F[0].Page_3[0].Daily1[0]",
                  "answer":""
               }
            ],
         },
         {
            "main":"Not required",
            "partialField": true,
            "dbqName":"F[0].Page_3[0].No2C[0]",
            "answer":""
         },     
      ],
      "answer":""
   },
   {
      "question":"Does ##name##'s respiratory condition require the use of Bronchodilators?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "3",
         title: "MEDICAL HISTORY",
         number: "2D"
      },
      "presidence":"Yes",
      "ref":1,
      "dbqName_yes":"F[0].Page_3[0].Yes2D[0]",
      "dbqName_no":"F[0].Page_3[0].No2D[0]",
      "answer":"",
   },
   {
      "question":"Indicate the frequency of use of Bronchodilators",
      "sub":"",
      "type":"radio",
      "show": false,
      "refId":1,
      "section": {
         page: "3",
         title: "MEDICAL HISTORY",
         number: "2D"
      },
      "questions":[
         {
            "label":"Indicate the frequency",
            "title":"",
            "subMain":"",
            "sub":"",
            "options":[
               {
                  "main":"Intermittent",
                  "dbqName":"F[0].Page_3[0].Intermittent2[0]",
                  "sub":""
               },
               {
                  "main":"Daily",
                  "dbqName":"F[0].Page_3[0].Daily2[0]",
                  "sub":""
               }
            ],
            "answer":"Intermittent"
         }
      ]
   },
   {
      "question":"Does ##name##'s respiratory condition require the use of Antibiotics?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "3",
         title: "MEDICAL HISTORY",
         number: "2E"
      },
      "maxLength": 40,
      "presidence":"Yes",
      "ref":0,
      "dbqName_yes":"F[0].Page_3[0].Yes2E[0]",
      "dbqName_no":"F[0].Page_3[0].No2E[0]",
      "answer":"",
      "istext": true,
      "textarea": false,
      "placeholder": "List antibiotics, dose, frequency and condition for which antibiotics are prescribed",
      "textdbqName":"F[0].Page_3[0].Note3[0]",
      "textanswer":""
   },
   {
      "question":"Does ##name## require outpatient oxygen therapy for his or her respiratory condition?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "3",
         title: "MEDICAL HISTORY",
         number: "2F"
      },
      "presidence":"Yes",
      "ref": 1,
      "dbqName_yes":"F[0].Page_3[0].Yes3A[0]",
      "dbqName_no":"F[0].Page_3[0].No3A[0]",
      "answer":"",
   },
   {
      "question":"Does ##name## require continuous oxygen therapy (>17 hours/day)?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "3",
         title: "MEDICAL HISTORY",
         number: "2E"
      },
      "maxLength": 90,
      "presidence":"Yes",
      "refId":1,
      "dbqName_yes":"F[0].Page_3[0].Yes3B[0]",
      "dbqName_no":"F[0].Page_3[0].No3B[0]",
      "answer":"",
      "istext": true,
      "textarea": false,
      "placeholder": "Indicate the condition which is predominantly responsible for the requirement for oxygen therapy",
      "textdbqName":"F[0].Page_3[0].Note3[1]",
      "textanswer":""
   },

   {
      "question":"Has ##name## had any asthma attacks with episodes of respiratory failure in the past 12 months?",
      "sub":"If yes, indicate average number of asthma attacks",
      "type":"checkbox",
      "multi": false,
      "small": true,
      "show": true,
      "cols": 2,
      "section": {
         page: "4",
         title: "PULMONARY CONDITIONS",
         number: "1A"
      },
      "questions":[
         {
            "main":"Yes",
            "dbqName":"F[0].Page_4[0].Yes4A[0]",
            "answer":"",
            "multi": false,
            "subAnswer":"",
            "subLabel": "Indicate average number of asthma attacks with episodes of respiratory failure per week in past 12 months",
            "textarea": false,
            "showSubItems": false,
            "subItems": [
               {
                  "main":"0",
                  "dbqName":"F[0].Page_4[0].Attacks1[0]",
                  "answer":""
               },
               {
                  "main":"1",
                  "dbqName":"F[0].Page_4[0].Attacks2[0]",
                  "answer":""
               },
               {
                  "main":"2",
                  "dbqName":"F[0].Page_4[0].Attacks3[0]",
                  "answer":""
               },
               {
                  "main":"3",
                  "dbqName":"F[0].Page_4[0].Attacks4[0]",
                  "answer":""
               },
               {
                  "main":"4 or more",
                  "dbqName":"F[0].Page_4[0].Attacks5[0]",
                  "answer":""
               }
            ],
         },
         {
            "main":"No",
            "dbqName":"F[0].Page_4[0].No4A[0]",
            "answer":""
         },         
      ],
      "answer":""
   },
   {
      "question":"Has ##name## had any physician visits for required care of exacerbations?",
      "sub":"If yes, describe the frequency and severity of exacerbations",
      "type":"radioTiles",
      "multi": false,
      "show": true,
      "textarea": false,
      "small": true,
      "cols": 2,
      "section": {
         page: "4",
         title: "PULMONARY CONDITIONS",
         number: "1B"
      },
      "questions":[
         {
            "main":"Less frequently than monthly",
            "dbqName":"F[0].Page_4[0].Yes4B[0],F[0].Page_4[0].Frequency2[0]",
            "answer":"",
            "textarea": true,
            "maxLength": 40,
            "textdbqName" : "F[0].Page_4[0].Note3[0]",
            "placeholder": "Describe the frequency and severity",
            "textAnswer": ""
         },
         {
            "main":"At least monthly",
            "dbqName":"F[0].Page_4[0].Yes4B[0],F[0].Page_4[0].Frequency1[0]",
            "answer":"",
            "textarea": true,
            "textdbqName" : "F[0].Page_4[0].Note3[0]",
            "placeholder": "Please describe",
            "textAnswer": ""
         },
         {
            "main":"No physician visits",
            "dbqName":"F[0].Page_4[0].No4B[0]",
            "answer":"",
         },
      ],
      "answer":"",
      "textAnswer": ""
   },

   {
      "question":"Additional Comments",
      "sub":"",
      "optional": true,
      "type":"textarea",
      "maxLength":800,
      "show": true,
      "section": {
         page: "8",
         title: "REMARKS",
         number: "6A"
      },
      "options":[],
      "dbqName":"F[0].Page_8[0].ProvideBriefSummary[2]",
      "answer":""
   }
]

export default Foot_questions;